import { restartApp } from './flows/initial-app';

restartApp();
